"use client"

import { Pill } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `PillIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const PillIcon = component(Icon)({ as: Pill })
